import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductMonitor20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_903)'>
      <path
        d='M8 9C8 9.55229 8.44771 10 9 10C9.55228 10 10 9.55229 10 9C10 8.44772 9.55228 8 9 8C8.44771 8 8 8.44772 8 9Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 5.49243C7.06011 5.49243 5.87907 7.06026 4.62678 8.31255C4.25235 8.68698 4.25235 9.31301 4.62678 9.68743C5.87907 10.9397 7.0601 12.5076 9 12.5076C10.9399 12.5076 12.1209 10.9397 13.3732 9.68743C13.7476 9.31301 13.7476 8.68698 13.3732 8.31255C12.1209 7.06026 10.9399 5.49243 9 5.49243ZM9 6.99243C10.2865 6.99243 11.1124 8.1731 11.9393 8.99999C11.1124 9.82689 10.2865 11.0076 9 11.0076C7.71346 11.0076 6.88755 9.82689 6.06066 8.99999C6.88755 8.1731 7.71346 6.99243 9 6.99243Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 11.0081 16.5325 12.8487 15.3399 14.2793L19.5303 18.4697L18.4696 19.5303L14.2793 15.34C12.8486 16.5325 11.0081 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75ZM15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_903'>
        <rect
          width='20'
          height='20'
          fill='white'
          transform='matrix(-1 0 0 1 20 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

ProductMonitor20.displayName = 'ProductMonitor20';
export default ProductMonitor20;
